/* Self-contained fade rotator for the Trustpilot reviews block.
   Custom element auto-initialises whenever it is connected to the DOM —
   including Section Rendering API re-renders in the theme editor. */
if (!customElements.get('trustpilot-rotator')) {
  class TrustpilotRotator extends HTMLElement {
    connectedCallback() {
      /* Setup already done → this is a reconnect. Just (re)start autoplay,
         which is what makes it rotate again after a re-render or DOM move. */
      if (this._setup) {
        this.start();
        return;
      }

      /* The block injects this script right before the element, so when the
         parser upgrades the element its children (slides, dots, arrows) may
         not exist yet. Wait until they are actually parsed before reading them
         — otherwise slides come back empty and go()/autoplay silently no-op. */
      var self = this;
      if (this.querySelector('[data-tp-slide]')) {
        this.setup();
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { self.setup(); }, { once: true });
      } else {
        requestAnimationFrame(function () { self.setup(); });
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    setup() {
      if (this._setup || !this.isConnected) return;
      var self = this;

      this.slides = this.querySelectorAll('[data-tp-slide]');
      this.dots = this.querySelectorAll('[data-tp-dot]');
      this.n = this.slides.length;
      if (!this.n) return; /* nothing to rotate; retry on next connect */
      this._setup = true;
      this.idx = 0;
      this.speed = parseInt(this.getAttribute('data-tp-autoplay') || '0', 10);

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.speed = 0;
      }

      var prev = this.querySelector('[data-tp-prev]');
      var next = this.querySelector('[data-tp-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.idx - 1); self.restart(); });
      if (next) next.addEventListener('click', function () { self.go(self.idx + 1); self.restart(); });
      for (var i = 0; i < this.dots.length; i++) {
        (function (j) {
          self.dots[j].addEventListener('click', function () { self.go(j); self.restart(); });
        })(i);
      }

      /* Pause on hover / keyboard focus so it never rotates out from under the
         visitor, and resume afterwards. */
      this.addEventListener('mouseenter', function () { self.stop(); });
      this.addEventListener('mouseleave', function () { self.start(); });
      this.addEventListener('focusin', function () { self.stop(); });
      this.addEventListener('focusout', function () { self.start(); });

      /* Pause while the tab is hidden (background timers are throttled and
         drift), resume when it becomes visible again. */
      this._onVis = function () {
        if (document.hidden) { self.stop(); } else { self.start(); }
      };
      document.addEventListener('visibilitychange', this._onVis);

      this.go(0);
      this.start();
    }

    go(i) {
      if (!this.n) return;
      this.idx = ((i % this.n) + this.n) % this.n;
      for (var j = 0; j < this.slides.length; j++) {
        this.slides[j].classList.toggle('is-active', j === this.idx);
      }
      for (var k = 0; k < this.dots.length; k++) {
        this.dots[k].classList.toggle('is-active', k === this.idx);
        this.dots[k].setAttribute('aria-current', k === this.idx ? 'true' : 'false');
      }
    }

    start() {
      /* Always clear first so we can never stack two intervals. */
      this.stop();
      if (this.speed > 0 && this.n > 1 && !document.hidden) {
        var self = this;
        this.timer = setInterval(function () { self.go(self.idx + 1); }, this.speed);
      }
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }
  customElements.define('trustpilot-rotator', TrustpilotRotator);
}
